export const allowedCharactersValidator = (value: unknown) => {
    if (!value || typeof value !== 'string') return true

    const pattern = /^[a-zA-Zа-яА-ЯёЁ0-9 –—-]+$/u
    return pattern.test(value)
}
